export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/bless-bag' */ './BlessBag'
  );
